import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="email-2, envelope"><path d="M2.10938 6.84473L10.988 11.3122C11.6242 11.6324 12.3745 11.6324 13.0107 11.3122L21.8894 6.84472C21.4844 5.211 20.0083 4 18.2494 4H5.74937C3.99044 4 2.51435 5.211 2.10938 6.84473Z" fill="currentColor"/><path d="M22 8.46857L13.6855 12.6522C12.6252 13.1857 11.3748 13.1857 10.3144 12.6522L2 8.46857V16.25C2 18.3211 3.67893 20 5.75 20H18.25C20.3211 20 22 18.3211 22 16.25V8.46857Z" fill="currentColor"/></CentralIconBase>;
};

export default IconEmail2;
